const riot = require('riot');

riot.tag2('modal-indicator', '<div class="modal white" ref="modal"> <div class="s100 s-s40" data-is="atom-loading"></div> </div>', 'modal-indicator,[data-is="modal-indicator"]{background-color:rgba(28,34,54,0.9)}', 'class="f fh" spat-animation="fade" spat-dismissible="{false}"', function(opts) {
});